const currenciesBaseApiUrl = 'https://api.ecosia.org/v2/currencies';
const availableCurrenciesUrl = `${currenciesBaseApiUrl}/currencies`;
const convertUrl = `${currenciesBaseApiUrl}/convert`;

/**
 * Requests the available currencies for exchange rates
 * Result is a list of places like:
{
    "AED": "United Arab Emirates Dirham",
    "AFN": "Afghan Afghani",
    "EUR": "Euro"
}
 * See full example in README.md
 *
 * @returns Promise
 */
export const requestCurrencies = async () => {
  const result = await fetch(availableCurrenciesUrl);
  const content = await result.json();

  return content;
};

/**
 * Requests the conversion result for two given currencies ("from" and "to") and amount
 * Result complete result is an object like:
{
    "disclaimer": "Usage subject to terms: https://openexchangerates.org/terms",
    "license": "https://openexchangerates.org/license",
    "request": {
        "query": "/convert/20/USD/EUR",
        "amount": 20,
        "from": "USD",
        "to": "EUR"
    },
    "meta": {
        "timestamp": 1675964100,
        "rate": 0.930116
    },
    "response": 18.60232
}
 * Where "response" is the calculated amount
 *
 * See full example in README.md
 *
 * @returns Promise
 */
// eslint-disable-next-line no-unused-vars
export const requestConvertedAmount = async (amount, sourceCurrency, targetCurrency) => {
  const result = await fetch(`${convertUrl}/${amount}/${sourceCurrency}/${targetCurrency}`);
  const content = await result.json();

  return {
    amount: content.response,
    conversionRate: content.meta.rate,
    timestamp: content.meta.timestamp,
  };
};
